// Teléfono MX con máscara 3-3-4 («555 123 4567»): muestra agrupado y entrega solo los 10 dígitos.
import { forwardRef } from 'react';
import { formatPhoneMx, toPhoneDigits } from '@/lib/phoneMx';
import { Input, type InputProps } from './forms';

export interface PhoneInputProps extends Omit<
    InputProps,
    'value' | 'onChange' | 'type' | 'inputMode'
> {
    /** Los dígitos del teléfono, sin máscara. */
    value: string;
    onValueChange: (digits: string) => void;
}

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
    ({ value, onValueChange, placeholder = '555 123 4567', ...props }, ref) => (
        <Input
            ref={ref}
            type="tel"
            inputMode="numeric"
            autoComplete="tel-national"
            placeholder={placeholder}
            value={formatPhoneMx(value)}
            onChange={(event) => {
                onValueChange(toPhoneDigits(event.target.value));
            }}
            {...props}
        />
    ),
);
PhoneInput.displayName = 'PhoneInput';
